import { FirebaseClient } from "../types";

export const injectMetadata = <T extends object>(data?: T, firebase: FirebaseClient) => ({
  createdAt: new Date().toString(),
  dataOwner: firebase.auth.currentUser.uid,
  ...data,
  updatedAt: new Date().toString()
});
